import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components';
import logo from 'src/assets/images/loading.gif';
export class TableLoader extends Component {
  render() {
    const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }`;
    const Spinner = styled.div`
    width: 100%; 
    height: 100%;
    position: fixed; 
    top: 0px; left: 0px; 
    z-index: 9999; 
    background: url(${logo}) center center / 100px no-repeat white; 

  `;


    return (
        <div style={{ padding: '24px' }}>
        	<Spinner />
                
        </div>
    )
  }
}

export default TableLoader
